import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api',
});

export const login = async (username, password) => {
  const response = await api.post('/token/', { username, password });
  return response.data; // { access, refresh }
};

export const logout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

export const getCurrentUser = async () => {
  const token = localStorage.getItem('accessToken');
  const response = await api.get('/auth/me/', {
      headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
